// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"CK-z","carouselContainer":"DK-z"};